import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-qrcode-dialog',
  templateUrl: './qrcode-dialog.component.html',
  styleUrls: ['./qrcode-dialog.component.scss'],
  standalone: false
})
export class QRCodeDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<QRCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QRCodeDialogData) { }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
export interface QRCodeDialogData {
  qrCode: string;
}
